// extracted by mini-css-extract-plugin
export default {"mCard":"WD-z","image":"XD-z","imageNoBackground":"YD-z","imageHasCategory":"ZD-z","fullWidth":"_D-z"};